'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function float(number, defNumber) {
  defNumber = defNumber || 0;
  if (!number) {
    return defNumber;
  }
  return parseFloat(number);
}
function boolean(value, defValue) {
  defValue = defValue || false;
  // console.log('value:',value, defValue )
  if (!value) {
    return defValue;
  }
  value = (value + '').toLowerCase();
  switch (value) {
    case '1':
      return true;
    case '0':
      return false;
    case 'true':
      return true;
    case 'false':
      return false;
    case 'yes':
      return true;
    case 'no':
      return false;
  }
  return false;
}
function int(number, defNumber) {
  defNumber = defNumber || 0;
  if (!number) {
    return defNumber;
  }
  return parseInt(number, 10);
}
exports.default = {
  float: float,
  boolean: boolean,
  int: int
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/convert.js
// module id = 32
// module chunks = 0